module.exports = __webpack_public_path__ + "static/media/notebook.5dfb6222.svg";